// extracted by mini-css-extract-plugin
export default {"wrapper":"TitleAfterImage_wrapper__uMawp","label":"TitleAfterImage_label__-ATOX","content":"TitleAfterImage_content__to3A5","animate":"TitleAfterImage_animate__kpOe6"};